export function scrollTop() {
  const btn = document.querySelector('.scroll-top-button');

  if (!btn) {
    return;
  }

  window.addEventListener('scroll', function() {
    if (window.scrollY > 500) {
      btn.classList.remove('opacity-0', 'pointer-events-none');
      btn.classList.add('opacity-100', 'pointer-events-auto');
    } else {
      btn.classList.remove('opacity-100', 'pointer-events-auto');
      btn.classList.add('opacity-0', 'pointer-events-none');
    }
  });

  btn.addEventListener('click', function(e) {
    e.preventDefault();
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}